<a mat-icon-button
   [routerLink]="link"
   [matTooltip]="tooltip">
  <mat-icon>arrow_back</mat-icon>
</a>
